import React from 'react';

import T from 'prop-types';

import cx from 'classnames';

import Container from '../../../../components/Container';

export const useStickySentinel = () => {
  const sentinelRef = React.useRef(null);

  return {
    sentinelNode: <div ref={sentinelRef} className="sticky-sentinel" />,
    sentinelRef,
  };
};

const DashboardStickyHeader = ({ headerLeft, headerRight, isSticky = false }) => (
  <div className="dashboard-sticky-header__outer">
    <div
      className={cx('dashboard-sticky-header', { 'dashboard-sticky-header--visible': isSticky })}
    >
      <Container maxWidth={1128}>
        <div className="dashboard-sticky-header__content">
          <div className="dashboard-sticky-header__left">{headerLeft}</div>
          {headerRight && <div className="dashboard-sticky-header__right">{headerRight}</div>}
        </div>
      </Container>
    </div>
  </div>
);

DashboardStickyHeader.propTypes = {
  headerLeft: T.node.isRequired,
  headerRight: T.node,
  isSticky: T.bool,
};

export default DashboardStickyHeader;
